import React, { useEffect } from "react";
import { Form, Button, Row, Col, Card } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { setFilters } from "../ItemStockSlice";
import {
  fetchGroups,
  fetchCategories,
  fetchItems,
  fetchLocations,
} from "../../../store/commonThunks/lookups";
import { fetchItemStockReport } from "../ItemStockThunk";
import SearchListAutoComplete from "../../../components/SearchListAutoComplete";
import { SearchOutlined } from "@ant-design/icons";

const ItemStockFilters = () => {
  const dispatch = useDispatch();
  const { filters } = useSelector((state) => state.itemStock);
  const lookups = useSelector((state) => state.lookups);

  const [form] = Form.useForm();
  const dynamicSpan = filters.filterType === "By Tag" ? 3 : 4;

  useEffect(() => {
    dispatch(fetchGroups());
    dispatch(fetchCategories());
    dispatch(fetchItems());
    dispatch(fetchLocations());
    dispatch(setFilters({ filterType: "All" }));
  }, [dispatch]);

  const handleSubmit = (values) => {
    const payload = {
      // warehouseId: values.warehouseId || null,
      // groupId: values.groupId || null,
      // categoryId: values.categoryId || null,
      // itemId: values.itemId || null,
      // showZeroStock: values.showZeroStock || "no",
      ...filters,
    };
    dispatch(setFilters(payload));
    dispatch(fetchItemStockReport(payload));
  };
  const handleFilterChange = (field, value) => {
    dispatch(setFilters({ itemId: "" }));
    dispatch(setFilters({ [field]: value }));
  };

  const renderExtraField = () => {
    switch (filters.filterType) {
      case "By Item":
        return (
          <Col xs={24} sm={12} md={6} lg={4} className="item-stock-filter-item">
            <label>Search Item</label>
            <SearchListAutoComplete
              entityType="item"
              optionsList={lookups.items.map((e) => ({
                sale_id: e.item_id,
                display_text: e.item_name,
              }))}
              onSelect={(obj) => handleFilterChange("itemId", obj?.sale_id)}
              placeholder="Item"
              showAddNew={false}
            />
          </Col>
        );

      case "By Group":
        return (
          <Col xs={24} sm={12} md={6} lg={4} className="item-stock-filter-item">
            <label>Search Group</label>
            <SearchListAutoComplete
              entityType="group"
              optionsList={lookups.groups.map((e) => ({
                sale_id: e.group_id,
                display_text: e.group_name,
              }))}
              onSelect={(obj) => handleFilterChange("groupId", obj?.sale_id)} // ✅ use sale_id
              placeholder="Group"
              showAddNew={false}
            />
          </Col>
        );

      case "By Category":
        return (
          <Col xs={24} sm={12} md={6} lg={4} className="item-stock-filter-item">
            <label>Search Category</label>
            <SearchListAutoComplete
              entityType="category"
              optionsList={lookups.categories.map((e) => ({
                sale_id: e.category_id,
                display_text: e.category_name,
              }))}
              onSelect={(obj) => handleFilterChange("categoryId", obj?.sale_id)}
              placeholder="Category"
              showAddNew={false}
            />
          </Col>
        );

      default:
        return null;
    }
  };

  return (
    <Card className="page-filters mb-4 shadow-md rounded-xl">
      <Form form={form} onFinish={handleSubmit}>
        <Row
          gutter={[55, 16]}
          align="middle"
          wrap
          style={{ alignItems: "center" }}
          className = "item-stock-filter-rows"
          // wrap={false}
          // style={{ gap: "2rem" }}
        >
          <Col xs={24} sm={12} md={6} lg={4} className="item-stock-filter-item">
            <label>Filter Type</label>
            <SearchListAutoComplete
              optionsList={[
                { sale_id: "All", display_text: "All" },
                { sale_id: "By Item", display_text: "By Item" },
                { sale_id: "By Group", display_text: "By Group" },
                { sale_id: "By Category", display_text: "By Category" },
              ]}
              value={
              filters.filterType
                ? { value: filters.filterType, label: filters.filterType }
                : undefined
            }
              onSelect={(obj) => {
              if(!obj) {
                handleFilterChange("filterType", null);
                return;
              } 
              handleFilterChange("filterType", obj?.sale_id);
            }}
              placeholder="Filter Type"
              showAddNew={false}
            />
          </Col>

          {renderExtraField()}

          <Col
            xs={24}
            sm={12}
            md={6}
            lg={4}
            style={{
              display: "flex",
              alignItems: "flex-end",
              paddingTop: "1rem",
            }}
          >
            <Button
              type="primary"
              icon={<SearchOutlined />}
              onClick={handleSubmit}
              block
            >
              Get Report
            </Button>
          </Col>
        </Row>
      </Form>
      {/* <style>{`
    @media (min-width: 768px) and (max-width: 1024px) {
      .page-filters .ant-row .ant-col {
        flex: 0 0 50% !important;
        max-width: 50% !important;
      }
    }
       @media (min-width: 768px) {
       .page-filters .ant-col {
          margin-bottom: 12px;
        }
  :where(.css-dev-only-do-not-override-1j5i8gz).ant-col-md-4 {
    max-width: none !important;
    flex: none !important;
  }
 }

  `}</style> */}
    </Card>
  );
};

export default ItemStockFilters;
